import { BaseApi } from '@/lib/api/baseApi'

export class InternalApi extends BaseApi {
  constructor() {
    super({
      baseURL: `${import.meta.env.VITE_HOST_URL}/api`,
      token: '',
    })
  }
}
